import  { Loader } from '../../react/Atoms/Loader';
import { uuid } from '../../../util/basket';
import { queryString } from '../../../util/location-helpers.js';
import SessionDataManager from '../../../util/storage-manager.js';
import { BP_BOOKING_KEY, BP_EMAIL_ADDRESS_KEY, BP_FIRST_DATA_PAYMENT_FORM_KEY, BP_PAYMENT_ERROR_KEY, BP_SUCCESS_KEY } from '../../../constants/balance-payments.js';

export default class {
  constructor(context) {
    this.context = context;

    this.init();
  }

  init() {
    // This page is the processing page we are brought back to once we have made a
    // payment with FirstData
    Loader();

    const bookingDetails = SessionDataManager.getStorageItem(BP_BOOKING_KEY);
    if (!bookingDetails) {
      window.location.href = '/';
      return;
    };

    const firstDataPaymentForm = SessionDataManager.getStorageItem(BP_FIRST_DATA_PAYMENT_FORM_KEY);
    const emailAddress = SessionDataManager.getStorageItem(BP_EMAIL_ADDRESS_KEY);

    this.bookingDetails = JSON.parse(bookingDetails);
    this.emailAddress = emailAddress;
    this.firstDataPaymentForm = JSON.parse(firstDataPaymentForm);

    const ApprovalCode = this.context.dataset.approvalCode;

    this.checkPaymentHash(ApprovalCode);
  }

  checkPaymentHash(ApprovalCode) {
    let StoreId = this.firstDataPaymentForm.StoreId;
    let Amount = this.firstDataPaymentForm.ChargeTotal;
    let TxnDate = this.firstDataPaymentForm.TxnDate;
    let Currency = this.firstDataPaymentForm.Currency;
    const responseHash = this.context.dataset.responseHash;

    let data = {
      StoreId,
      Amount,
      TxnDate,
      Currency,
      ApprovalCode,
    };
    let headers = new Headers();
    headers.set('Content-Type', 'application/json');
    return fetch('/api/Booking/GetFirstDataHash', {
      method: 'post',
      body: JSON.stringify(data),
      headers: headers
    })
    .then((response) => response.json())
    .then((responseJson) => {
      if (responseJson === responseHash) {
        this.completePayment(ApprovalCode);
      } else {
        window.location.href = this.firstDataPaymentForm.PaymentErrorUrl;
      }
    });
  }

  completePayment(ApprovalCode) {
    const BookingRefId = this.bookingDetails.Detail.BookingReference;
    const LeadSurname = this.bookingDetails.Detail.LeadPassengerName;
    const DepartureDate = this.bookingDetails.Detail.DepartureDate;
    const EmailAddress = this.emailAddress;
    const Amount = this.firstDataPaymentForm.ChargeTotal;
    const ClientAddress1 = this.bookingDetails.Client.Address1;
    const ClientAddress2 = this.bookingDetails.Client.Address2;
    const ClientTownCity = this.bookingDetails.Client.TownCity;
    const ClientAddressPostcode = this.bookingDetails.Client.PostCode;
    const FirstDataReference = this.context.dataset.firstDataReference;
    const PaymentType = this.context.dataset.paymentType;
    const Status = this.context.dataset.status;
    const FailedReason = this.context.dataset.failedReason;
    const SessionId = 123;

    const data = {
      PackageParameters: {
        TraceGUID: uuid()
      },
      CreateBalancePaymentRequest: {
        BookingRefId,
        LeadSurname,
        DepartureDate,
        EmailAddress,
        Amount,
        ClientAddress1,
        ClientAddress2,
        ClientTownCity,
        ClientAddressPostcode,
        CreateBookingRequest: {
          SessionId,
          Payment: {
            FirstDataReference,
            PaymentType,
            ApprovalCode,
            Status,
            FailedReason,
          },
        }
      ,}
    };
    let headers = new Headers();
    headers.set('Content-Type', 'application/json');
    return fetch('/api/Booking/MakeBalancePayment', {
      method: 'post',
      body: JSON.stringify(data),
      headers: headers,
      credentials: 'include'
    })
    .then((response) => response.json())
    .then((responseJson) => {
      if (responseJson.BalancePaymentResponse.Success) {
        SessionDataManager.setStorageItem(BP_SUCCESS_KEY, true);
      } else {
        SessionDataManager.setStorageItem(BP_PAYMENT_ERROR_KEY, responseJson.ErrorMessage);
      }
      window.top.location.href = responseJson.RedirectUrl;
    })
    .catch((response) => {
      console.error('Making payment completely failed.');
      SessionDataManager.setStorageItem(BP_PAYMENT_ERROR_KEY, response);
    });
  }
}